import { Box, Typography } from '@mui/material';
import Article from '../../../types/Article';
import { Fragment } from 'react';
import VideoPlayer from '../../Videos/components/VideoPlayer';
import ArticleContentSection from '../../../components/Article/ArticleContentSection';

export function isListElement(element: Element): boolean {
  return (
    element.tagName.toUpperCase() === 'OL' ||
    element.tagName.toUpperCase() === 'UL'
  );
}

export function nextSiblingIsList(element: Element): boolean {
  return (
    !!element.nextElementSibling && isListElement(element.nextElementSibling)
  );
}

export function getArticleElement(element: Element, article: Article) {
  const marginBottom = nextSiblingIsList(element) ? 1 : 2;
  const paddingTop = isListElement(element) ? 0 : 2;
  const shouldRenderArticleTitle =
    element.tagName.toUpperCase() === 'H1' &&
    element.textContent !== undefined &&
    element.textContent !== '' &&
    article.meta.title !== undefined;

  if (shouldRenderArticleTitle) {
    return (
      <Fragment key={element.getAttribute('data-tp')}>
        <Typography variant='h1' id={encodeURIComponent(article.meta.title)}>
          {article.meta.title}
        </Typography>
        {article.meta.hasVideoContent() && (
          <Box
            sx={{
              marginBottom: {
                xs: '1rem',
                sm: '1.5rem',
                md: '1.75rem',
              },
            }}
          >
            <VideoPlayer videoPlayListID={article.meta.videoPlayListId} />
          </Box>
        )}
      </Fragment>
    );
  }

  return (
    <ArticleContentSection
      key={element.getAttribute('data-tp')}
      marginBottom={marginBottom}
      paddingTop={paddingTop}
      originalElement={element}
    />
  );
}
